import { useEffect, useState } from 'react';

/**
 * Delays a fast-changing value (search boxes) so each keystroke does not become
 * a request. The list shells all type their search input through this.
 */
export function useDebounced<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
